module.exports = __webpack_public_path__ + "media/St 4-charging station-correct.3bd4faf6.wav";